


export const fonts={  
    FONT_PRIMARY:"Outfit, sans-serif",
    FONT_SECONDARY:"Roboto, sans-serif"
}